import { render } from "./Card.vue?vue&type=template&id=0aa0ffa0&scoped=true"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"

import "./Card.vue?vue&type=style&index=0&id=0aa0ffa0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aa0ffa0"]])

export default __exports__